import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { MoreActionsDropdown } from 'module/ui/components/atoms/more-actions';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FolderItem } from '../types';

const ActionsCellWrapper = styled.div`
  display: flex;
  opacity: 0;
  transition: opacity 0.2s;
  .ag-row-hover & {
    opacity: 1;
  }
`;

export const ActionsCell: FC<{
  data: FolderItem;
  onDelete?: (data: FolderItem) => void;
  onEdit?: (data: FolderItem) => void;
}> = ({ data, onDelete, onEdit }) => {
  const canEdit = useMemo(() => {
    return data.type === 'file' && data.actualContentType === 'AI_PAGE';
  }, [data.actualContentType, data.type]);

  return (
    <ActionsCellWrapper onClick={(e) => e.stopPropagation()}>
      <MoreActionsDropdown
        menu={{
          onClick: ({ key }) => {
            if (key === 'delete') {
              onDelete?.(data);
            }
            if (key === 'edit') {
              onEdit?.(data);
            }
          },
          items: [
            {
              type: 'group',
              label: <FormattedMessage id="more_actions" />,
              children: [
                ...(canEdit
                  ? ([
                      {
                        key: 'edit',
                        label: <FormattedMessage id="edit" />,
                        icon: <FontAwesomeIcon icon={faEdit} />,
                      },
                      {
                        type: 'divider',
                      },
                    ] as any[])
                  : []),
                {
                  key: 'delete',
                  label: <FormattedMessage id="delete" />,
                  icon: <FontAwesomeIcon icon={faTrashCan} />,
                  danger: true,
                },
              ],
            },
          ],
        }}
      />
    </ActionsCellWrapper>
  );
};
